(() => {
  // eslint-disable-next-line no-prototype-builtins
  if (HTMLTemplateElement.prototype.hasOwnProperty('shadowRoot')) {
    return;
  }

  window.swinger.observer.initialize('.swinger-shadow-dom template[shadowroot]', (template) => {
    const mode = template.getAttribute('shadowroot');
    const shadowRoot = template.parentNode.attachShadow({ mode });
    shadowRoot.appendChild(template.content);
    template.remove();
  }, false);
})();
